import { getJson } from "./client";

/**
 * The model gateway: which models the envoy may think with. The shapes
 * are `libs/crates/api/src/llm_gateway_api`. Prices and weights are
 * decimal strings, read with `amount()` from billing.
 */
export const LLM_BASE = "/v1/llm";

export interface LlmModel {
    provider: string;
    /** The provider as people write it: "Mistral". */
    company: string;
    /** The id a request and the envoy's settings name. */
    model: string;
    family: string;
    version: string;
    display_name: string;
    /** One or two sentences for the picker. */
    description: string;
    input_usd_per_million_tokens: string;
    cache_read_usd_per_million_tokens: string;
    cache_write_usd_per_million_tokens: string;
    output_usd_per_million_tokens: string;
    enabled: boolean;
    available: boolean;
}

export interface ModelListing {
    models: LlmModel[];
}

/** Cheapest first. A person sees every model the gateway can call. */
export function getModels(): Promise<ModelListing> {
    return getJson(`${LLM_BASE}/models`);
}
